import { withStyles } from '@material-ui/core/styles';
import {colorDarkBlack, colorBlueBlack} from './styles';
import TableCell from '@material-ui/core/TableCell';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colorBlueBlack,
    color: theme.palette.common.white,
    fontSize: 14,
    padding: '5px 8px',
    [theme.breakpoints.up('md')]: {
      padding: '10px 16px',
    },
		letterSpacing: '0.1px',
		'&:hover span, &:active span': {
      color:"white"
		}
  },
  body: {
    fontSize: 14,
    padding: '9px 8px',
    letterSpacing: '0.25px',
    lineHeight: '20px',
    borderBottom: `1px solid ${colorDarkBlack}`,
    [theme.breakpoints.up('md')]: {
      padding: '18px 16px'
    }
  },
}))(TableCell);

export default CustomTableCell;



// WEBPACK FOOTER //
// ./src/js/components/Mui/TableCell.js